import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { useMutation, useLazyQuery } from "@apollo/client";
import { CREATE_USER_CONFIRM } from "../../apollo/userconfirm/mutation";
import { GET_USER_TYPE } from "../../apollo/userType/mutation";
import { LaoAddress } from "../../const/laoAddress";
import Swal from "sweetalert2";

const CreateCustomerModal = ({ show, onHide, shopId, onCustomerCreated }) => {
  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [gender, setGender] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState("");
  const [province, setProvince] = useState("");
  const [district, setDistrict] = useState("");
  const [village, setVillage] = useState("");

  const [newUserTypeData, setNewUserTypeData] = useState([]);

  const [getUserTypeData, { data: userTypeDataRes, loading: getUserTypeLoading }] = useLazyQuery(GET_USER_TYPE, {
    fetchPolicy: "cache-first",
  });

  const [createUserConfirm, { loading: loadingCreate }] = useMutation(CREATE_USER_CONFIRM);

  useEffect(() => {
    if (show) {
      getUserTypeData();
    }
  }, [show, getUserTypeData]);

  useEffect(() => {
    if (userTypeDataRes?.getUserTypes) {
      const data = userTypeDataRes.getUserTypes.filter((item) => item?.isOpen);
      setNewUserTypeData(data);
      if (data.length > 0 && !userType) {
        setUserType(data[0].id);
      }
    }
  }, [userTypeDataRes]);

  const handleSubmit = async () => {
    if (!name) {
      Swal.fire("ແຈ້ງເຕືອນ", "ກະລຸນາປ້ອນຊື່ລູກຄ້າ", "warning");
      return;
    }

    try {
      const res = await createUserConfirm({
        variables: {
          data: {
            shop: shopId,
            name,
            lastname,
            gender,
            phone,
            userType: userType || (newUserTypeData[0]?.id),
            address: {
              province,
              district,
              village,
            },
          },
        },
      });

      if (res?.data?.createUserConfirm?.id) {
        Swal.fire("ສຳເລັດ", "ເພີ່ມລູກຄ້າສຳເລັດ", "success");
        if (onCustomerCreated) {
          onCustomerCreated(res.data.createUserConfirm);
        }
        handleClose();
      }
    } catch (error) {
      console.error(error);
      Swal.fire("ຜິດພາດ", "ລາຍຊື່ລູກຄ້ານີ້ອາດມີຢູ່ແລ້ວ ຫຼື ເກີດຂໍ້ຜິດພາດບາງຢ່າງ", "error");
    }
  };

  const handleClose = () => {
    setName("");
    setLastname("");
    setGender("");
    setPhone("");
    setUserType("");
    setProvince("");
    setDistrict("");
    setVillage("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18, fontWeight: "bold" }}>ເພີ່ມລູກຄ້າໃໝ່</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: "1em" }}>
          <Form>
            <div className="d-flex justify-content-between align-items-center gap-4">
              <Form.Group className="mb-3 w-100" controlId="formGroupName">
                <Form.Label>ຊື່</Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="ປ້ອນຊື່..."
                />
              </Form.Group>
              <Form.Group className="mb-3 w-100" controlId="formGroupLastname">
                <Form.Label>ນາມສະກຸນ</Form.Label>
                <Form.Control
                  type="text"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  placeholder="ປ້ອນນາມສະກຸນ..."
                />
              </Form.Group>
            </div>
            <Row>
              <Col>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formGroupGender">
                      <Form.Label>ເພດ</Form.Label>
                      <Form.Select
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        aria-label="Default select example"
                      >
                        <option value="">--ເລືອກ--</option>
                        <option value="male">ຊາຍ</option>
                        <option value="female">ຍິງ</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formGroupPhone">
                      <Form.Label>ເບີໂທລູກຄ້າ</Form.Label>
                      <Form.Control
                        type="tel"
                        inputMode="numeric"
                        maxLength={8}
                        pattern="[0-9]{8}"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="ປ້ອນເບີໂທ..."
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>ປະເພດລູກຄ້າ</Form.Label>
                  {getUserTypeLoading ? (
                    <p>ກຳລັງໂຫລດ...</p>
                  ) : (
                    <Form.Select
                      value={userType}
                      onChange={(e) => setUserType(e.target.value)}
                      required
                      aria-label="Default select example"
                    >
                      {newUserTypeData.map((i) => (
                        <option key={i?.id} value={i?.id}>
                          {i?.name}
                        </option>
                      ))}
                    </Form.Select>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div style={{ marginBottom: 5, opacity: 0.7 }}>ຂໍ້ມູນທີ່ຢູ່</div>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupProvince">
                  <Form.Label>ແຂວງ</Form.Label>
                  <Form.Select
                    value={province}
                    onChange={(e) => {
                      setProvince(e.target.value);
                      setDistrict(""); // Reset district when province changes
                    }}
                    aria-label="Default select example"
                  >
                    <option value="">--ເລືອກ--</option>
                    {LaoAddress.map((p, index) => (
                      <option key={"province" + index} value={p?.province_name}>
                        {p?.province_name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupDistrict">
                  <Form.Label>ເມືອງ</Form.Label>
                  <Form.Select
                    disabled={!province}
                    value={district}
                    onChange={(e) => setDistrict(e.target.value)}
                    aria-label="Default select example"
                  >
                    <option value="">--ເລືອກ--</option>
                    {province &&
                      LaoAddress.find((f) => f.province_name === province)?.district_list.map((p, index) => (
                        <option key={"district" + index} value={p?.district}>
                          {p?.district}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label>ບ້ານຢູ່ປັດຈຸບັນ</Form.Label>
                <Form.Group className="mb-3" controlId="formGroupVillage">
                  <Form.Control
                    type="text"
                    value={village}
                    onChange={(e) => setVillage(e.target.value)}
                    placeholder="ປ້ອນຊື່ບ້ານ..."
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          ຍົກເລີກ
        </Button>
        <Button variant="success" onClick={handleSubmit} disabled={loadingCreate}>
          {loadingCreate ? <Spinner size="sm" animation="border" /> : "ບັນທຶກ"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateCustomerModal;
